import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LOGO from "../assets/final_logo.jpg";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "HOME", path: "/" },
    { name: "ABOUT", path: "/about" },
    { name: "GALLERY", path: "/gallery" },
    { name: "E-BOOKS", path: "/ebooks" },
     { name: "Donation", path: "/donation" },
    { name: "ACTIVITIES", path: "/activities" },
    { name: "CONTACT US", path: "/contact" },
  ];

  return (
    <nav className="backdrop-blur-md bg-white/90 border-b border-amber-200/50 shadow-md sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex justify-between items-center h-16">
        {/* Logo Section */}
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={LOGO}
            alt="Radha Krishna Logo"
            className="h-11 w-11 rounded-full border-2 border-amber-500 shadow-md group-hover:rotate-6 transition-transform duration-500"
          />
          <span className="text-amber-950 font-serif font-bold text-lg sm:text-xl tracking-wider group-hover:text-amber-700 transition-colors">
            RKGVK
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex space-x-8">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.name}
                to={item.path}
                className={`relative font-semibold text-[14px] tracking-widest uppercase py-1 transition-all duration-300 ${
                  isActive
                    ? "text-amber-800"
                    : "text-stone-600 hover:text-amber-700"
                }`}
              >
                {item.name}
                <span
                  className={`absolute left-0 bottom-0 h-[2px] bg-amber-600 transition-all duration-300 ${
                    isActive ? "w-full" : "w-0 hover:w-full"
                  }`}
                />
              </Link>
            );
          })}
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-stone-700 hover:text-amber-700 focus:outline-none transition-colors"
          >
            {isOpen ? (
              <svg
                className="w-6 h-6 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
              </svg>
            ) : (
              <svg
                className="w-6 h-6 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="lg:hidden bg-white border-b border-amber-100 px-6 pb-6 pt-2 flex flex-col space-y-4 shadow-inner">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={`block font-semibold text-[14px] tracking-widest uppercase transition-all duration-300 ${
                location.pathname === item.path
                  ? "text-amber-800 border-l-2 border-amber-600 pl-3"
                  : "text-stone-600 hover:text-amber-700 hover:pl-2"
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
